/* eslint-disable sonarjs/no-duplicate-string */
import {
  CUSTOMIZATION_LABEL_TO_SECTION_METADATA_KEY,
  DEFAULT_LABELS_PER_SECTION_KEY,
  SECTIONS_METADATA,
} from "../../../reports";
import {
  dataTableCopy,
  liveAccountsCopy,
} from "../../../resources/dataTableCopy";

const defaultFootnotesData = {
  type: "div",
  props: { className: "footnotes" },
  children: [
    {
      type: "p",
      props: { className: "footnotes__subheader" },
      children: dataTableCopy.unlessOtherwiseStated,
    },
    {
      type: "p",
      props: { className: "footnotes__item" },
      children: `[1] ${dataTableCopy.targetPortfoliosAndModels}`,
    },
    {
      type: "p",
      props: { className: "footnotes__item" },
      children: `[2] ${dataTableCopy.seeDefinitionsPage}`,
    },
  ],
};
const footnotes = {
  "1-Sheeter Summary": null,
  "Coupon Cash Flow": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: dataTableCopy.unlessOtherwiseStated,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfoliosAndModels}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `${dataTableCopy.couponCashFlowCalculatedContinue}`,
      },
    ],
  },
  "Credit Quality": defaultFootnotesData,
  Definitions: {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: `${dataTableCopy.corporateSecuritiesDrawn}`,
      },
    ],
  },
  Disclosures: null,
  "ESG Rating": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: dataTableCopy.unlessOtherwiseStated,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfoliosAndModels} ${dataTableCopy.investmentStrategiesNotESG}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[2] ${dataTableCopy.seeDefinitionsPage}`,
      },
    ],
  },
  "Firm Overview": null,
  "Interest Rate Analysis": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: dataTableCopy.unlessOtherwiseStated,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfoliosAndModels}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `${dataTableCopy.hypotheticalInterestRate}`,
      },
    ],
  },
  "Key Rate Durations": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: dataTableCopy.unlessOtherwiseStated,
      },
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: dataTableCopy.keyRateDurations,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfoliosAndModels}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[2] ${dataTableCopy.seeDefinitionsPage}`,
      },
    ],
  },
  Maturity: defaultFootnotesData,
  "Portfolio Characteristics": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: dataTableCopy.unlessOtherwiseStated,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfoliosAndModels} ${liveAccountsCopy.corp} ${dataTableCopy.cashExcludedFromTimeToMaturity}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[2] ${dataTableCopy.seeDefinitionsPage}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[3] ${dataTableCopy.yieldToWorstAndMaturity}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[4] ${dataTableCopy.couponCashFlowCalculatedContinue}`,
      },
    ],
  },
  "Proposed Portfolio": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: dataTableCopy.unlessOtherwiseStated,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfoliosAndModels}`,
      },
    ],
  },
  "Scenario Analysis": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: dataTableCopy.unlessOtherwiseStated,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfoliosAndModels}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `${dataTableCopy.hypotheticalInflationAnalysis}`,
      },
    ],
  },
  // Sectors: defaultFootnotesData,
};

const labels = {
  "1-Sheeter Summary": {
    Proposal: "Remi Cash Proposal",
  },
  "Coupon Cash Flow": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Coupon Cash Flow"],
    "Proposed Coupon Cash Flow Profile": "Proposed Coupon Cash Flow Profile[1]",
  },
  "Credit Quality": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Credit Quality"],
    "Proposed Credit Quality": "Proposed Credit Quality",
    "Target Portfolio": ["Target", "Portfolio[1]"],
    Model: "Model[2]",
    "Reference Index": ["Reference", "Index[2]"],
  },
  "ESG Rating": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["ESG Rating"],
    "ESG Rating": "Proposed ESG Rating",
    "Target Portfolio": ["Target", "Portfolio[1]"],
    Model: "Model[2]",
    "Reference Index": ["Reference", "Index[2]"],
  },
  "Interest Rate Analysis": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Interest Rate Analysis"],
    "Interest Rate Analysis": "Interest Rate Sensitivity Analysis[1]",
    "Interest Rate Sensitivity Analysis":
      "Interest Rate Sensitivity Analysis[1]",
  },
  "Key Rate Durations": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Key Rate Durations"],
    "Target Portfolio": ["Target", "Portfolio[1]"],
    Model: "Model[2]",
    "Reference Index": ["Reference", "Index[2]"],
  },
  Maturity: {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Maturity"],
    "Target Portfolio": ["Target", "Portfolio[1]"],
    Model: "Model[2]",
    "Reference Index": ["Reference", "Index[2]"],
  },
  "Portfolio Characteristics": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Portfolio Characteristics"],
    "Target Portfolio": ["Target", "Portfolio[1]"],
    Model: "Model[2]",
    "Reference Index": ["Reference", "Index[2]"],
    "Yield to Maturity": "Yield to Maturity[3]",
    "Yield to Worst": "Yield to Worst[3]",
    "Coupon Income (Next 12 months)": "Coupon Income (Next 12 months)[4]",
  },
  "Proposed Portfolio": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Proposed Portfolio"],
    "Target Portfolio": ["Target", "Portfolio[1]"],
  },
  "Scenario Analysis": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Scenario Analysis"],
    "Scenario Analysis": "Scenario Analysis[1]",
  },
  Sectors: {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Sectors"],
    "Target Portfolio": ["Target", "Portfolio[1]"],
    Model: "Model[2]",
    "Reference Index": ["Reference", "Index[2]"],
  },
};

export const getCashCorpMetadata = () => {
  return Object.entries(SECTIONS_METADATA).reduce(
    (acc, [sectionMetadataKey, staticSectionMetadata]) => {
      const labelsKey = Object.keys(
        CUSTOMIZATION_LABEL_TO_SECTION_METADATA_KEY
      ).find(
        (key) =>
          CUSTOMIZATION_LABEL_TO_SECTION_METADATA_KEY[key] ===
          sectionMetadataKey
      );

      const titleOverride = labels[labelsKey]?.[staticSectionMetadata.title];

      const updatedSectionMetadata = {
        ...staticSectionMetadata,
        reportType: "cash",
        assetType: "corp",

        footnotes:
          footnotes[staticSectionMetadata.customizations.label] ||
          staticSectionMetadata.footnotes,
        labels: labels[staticSectionMetadata.customizations.label],
        title:
          (Array.isArray(titleOverride)
            ? titleOverride.join(" ")
            : titleOverride) || staticSectionMetadata.title,
        table1: staticSectionMetadata.table1 && {
          ...staticSectionMetadata.table1,
          tableRowHeaderKey:
            labels[labelsKey]?.[
              staticSectionMetadata?.table1?.tableRowHeaderKey
            ] || staticSectionMetadata.table1?.tableRowHeaderKey,
        },
      };
      return {
        ...acc,
        [sectionMetadataKey]: updatedSectionMetadata,
      };
    },
    {}
  );
};
